export default {
  SIGN_IN: "SIGN_IN",
  FETCHING_SURVEYS: "FETCHING_SURVEYS",
  CHOOSE_SURVEY: "CHOOSE_SURVEY",
  REDIRECTING: "REDIRECTING"
}
